export default __webpack_public_path__ + "static/char-v-14-21aba5fc48712122192e0deccc657076.webp";